import React from 'react'

import { useGetConfigQuery } from '@/slices/config'

import { Select } from '../Select'

import type { Control, FieldError, RegisterOptions } from 'react-hook-form'

type CurrencySelectProps = {
  label: string
  name: string
  control: Control<any>
  rules?: RegisterOptions<any, string>
  error?: FieldError
}

export const CurrencySelect = ({
  label,
  name,
  control,
  ...restProps
}: CurrencySelectProps) => {
  const { data: config, isLoading } = useGetConfigQuery()

  return (
    <Select
      disabled={isLoading}
      options={config?.currencyList.map((currency) => ({
        label: currency.title,
        value: currency.id,
      }))}
      label={label}
      name={name}
      control={control}
      {...restProps}
    />
  )
}
